import Building from "@models/building/Building";
import Unit from "@models/building/Unit";
import Unitairvolume from "@models/airvolumes/Unitairvolume";
import Roomairvolume from "@models/airvolumes/Roomairvolume";
import store from "@store";
import Systemselection from "@models/airvolumes/Systemselection";
import Installation from "@models/airvolumes/Installation";
import Valve from "@models/airvolumes/Valve";
import RoomtypesHasOperationmodesHasAirvolume from "@models/helpers/RoomtypesHasOperationmodesHasAirvolume";

import {calculateValves} from "@services/calculations/valveCalculation";

let unit;
let building;

let fLstnl;
let fLstil;
let fLstrl;
let fLstfl;

let intervalCounter = 0;

export function calculateWrgAirvolumes(unitId) {
  building = Building.query().first();
  unit = Unit.query().where("id", unitId).with(["airvolume", "installation", "systemselection", "rooms.airvolume"]).first();

  if (unit.airvolumeUpdate == 'loaded') {
    getConstants();
    basicCalculations();
    fZuCalculation();

    checkDefaultSupplyAir();
    
    calculateTotalAirvolumes();
    calculateAirvolumeVariations();
    Unitairvolume.insertOrUpdate({data: [unit.airvolume]});
    unit.rooms.forEach((room) => {
      Roomairvolume.insertOrUpdate({data: [room.airvolume]});
    });
    return;
  }
  if (unit.rooms.length <= 0) return;

  if (unit.airvolume == null) {
    unit.airvolume = new Unitairvolume({unitId: unit.id});
  }
  if (unit.systemselection == null) {
    unit.systemselection = new Systemselection({
      unitId: unit.id,
      deviceLevel: unit.level,
    })
  }
  if (unit.installation == null) {
    unit.installation = new Installation({
      unitId: unit.id,
      storey: unit.storey,
    })
  }
  unit.rooms.forEach((room) => {
    if (room.airvolume == null) {
      room.airvolume = new Roomairvolume({roomId: room.id, doorLeaf: room.getRoomtypeDoorLeaf()});
    }
    if (room.airvolume.doorLeaf == 0 || room.airvolume.doorLeaf == null) {
      room.airvolume.doorLeaf = room.getRoomtypeDoorLeaf();
    }
    if (room.airType == 3) room.airvolume.resetOverflowRoom();
  });

  getConstants();
  basicCalculations();
  fZuCalculation();

  totalExhaustAirCalculation();
  calculateEquation8();
  calculateEquation28();
  if (unit.airvolume.manually != 1) {
    checkFrZu();
    calculateSupplyAir();
    calculateExhaustAir();
  }
  calculateTotalAirvolumes();
  calculateAirvolumeVariations();

  calculateUld();
  Unitairvolume.insertOrUpdate({data: [unit.airvolume]});
  Systemselection.insertOrUpdate({data: [unit.systemselection]});
  Installation.insertOrUpdate({data: [unit.installation]});

  unit.rooms.forEach((room) => {
    Roomairvolume.insertOrUpdate({data: [room.airvolume]});
  });
  calculateValves(unitId, true, 'valves');
}

function getConstants() {
  fLstnl = store.getters["constants/getFlstnl"];
  fLstil = store.getters["constants/getFlstil"];
  fLstrl = store.getters["constants/getFlstrl"];
  fLstfl = store.getters["constants/getTable6Constant"]({
    buildingHeatProtection: building.heatProtection,
    unitOccupancy: unit.occupancy
  });
}

function basicCalculations() {
  unit.airvolume.space = 0;
  unit.airvolume.height = 0;
  unit.airvolume.volume = 0;

  unit.rooms.forEach(
    function (room) {
      unit.airvolume.space += room.space;
      unit.airvolume.height += room.height;
    }.bind(this)
  );

  unit.airvolume.height = unit.airvolume.height / unit.rooms.length;
  unit.airvolume.volume = +parseFloat((unit.airvolume.space * unit.airvolume.height).toFixed(2));
}

function fZuCalculation() {
  let totalFrZu = unit.airvolume.totalFrZu;
  let newTotalFrZu = 0;
  unit.airvolume.totalFrZu = 0;
  unit.airvolume.totalFrZuKorr = 0;
  let reset = false;
  unit.rooms.forEach((room) => {
    if (room.airType != 2 || room.ventilationMeasure == 2) return;
    if (room.airvolume.fZu === null || room.airvolume.fZu <= null) {
      reset = true;
      return;
    }
    newTotalFrZu += room.airvolume.fZu;
  });
  if (newTotalFrZu != totalFrZu) reset = true;
  unit.rooms.forEach((room) => {
    if (reset === true) room.airvolume.resetFZu = true;
    room.airvolume.setFZu();
    unit.airvolume.totalFrZu += room.airvolume.fZu;
    unit.airvolume.totalFrZuKorr += room.airvolume.fZuKorr;
  });
}

function totalExhaustAirCalculation() {
  unit.airvolume.exhaustAir = 0;
  unit.rooms.forEach((room) => {
    if (room.airType != 1 || room.ventilationMeasure == 7) return;
    unit.airvolume.exhaustAir += room.getRoomtypeAirvolume();
  });
}

function calculateEquation8() {
  if (unit.airvolume.space < 210) {
    unit.airvolume.nl = fLstnl * (-0.002 * Math.pow(unit.airvolume.space, 2) + 1.15 * unit.airvolume.space + 11);
  } else {
    unit.airvolume.nl = ((unit.airvolume.space - 210) / 10) * 4 + fLstnl * (-0.002 * Math.pow(210, 2) + 1.15 * 210 + 11);
  }
}

function calculateEquation28() {
  unit.airvolume.nl = +parseFloat(Math.max(unit.airvolume.nl, Math.min(unit.airvolume.exhaustAir, 1.2 * unit.airvolume.nl))).toFixed(2);
}

function checkFrZu() {
  // check if airvoume < min airvolume and user changed fZu
  let airvolumeValid = true;
  let fZuChanged = false;

  unit.rooms.forEach((room) => {
    let roomtype = room.getRoomtype();
    if (room.airType != 2) return;
    if (room.getRoomtypeAirvolume() > Math.round((unit.airvolume.nl / unit.airvolume.totalFrZuKorr) * room.airvolume.fZuKorr)) airvolumeValid = false;
    if (+parseFloat(roomtype.f_zu).toFixed(1) != room.airvolume.fZuKorr) fZuChanged = true;
  });
  if (airvolumeValid === false && fZuChanged === true) {
    unit.rooms.forEach((room) => (room.airvolume.resetFZuKorr = true));
    fZuCalculation();
    store.dispatch("alert/setAlert", {
      type: "info",
      message: "Luftvolumen unterschreitet Mindestmenge. Verteilungsfaktor wurde zurückgesetzt."
    });
  }
}

function calculateSupplyAir() {
  unit.airvolume.totalSupplyAir = 0;

  unit.rooms.forEach((room) => {
    if (room.airType != 2) return;
    room.airvolume.isDefault = false;
    room.airvolume.fZu = room.airvolume.fZuKorr;
    room.airvolume.airvolume = Math.round((unit.airvolume.nl / unit.airvolume.totalFrZuKorr) * room.airvolume.fZuKorr);
  });

  if (
    unit.rooms.some((room) => {
      return (room.airType == 2 && room.getRoomtypeAirvolume() > room.airvolume.airvolume) || Math.abs(room.airvolume.getDefaultFzu() - room.airvolume.fZuKorr) > room.airvolume.getDefaultFzuDelta();
    })
  ) {
    intervalCounter = 0;
    calculateDefaultSupplyAir();
    checkDefaultSupplyAir();
  }
  unit.airvolume.totalFrZu = 0;
  unit.rooms.forEach((room) => {
    if (room.airType != 2 || room.ventilationMeasure == 2) return;
    if (room.ventilationMeasure == 7) {
      room.airvolume.airvolume = 0;
      return;
    }
    room.airvolume.fZu = room.airvolume.fZuKorr;
    unit.airvolume.totalFrZu += room.airvolume.fZu;
    unit.airvolume.totalSupplyAir += room.airvolume.airvolume;
  });
}

function calculateDefaultSupplyAir() {
  let changes = false;
  if (intervalCounter == 0) {
    unit.rooms.forEach((room) => (room.airvolume.resetFZu = true));
  }
  fZuCalculation();

  unit.rooms.forEach(
    function (room) {
      if (!(room.airType == 2 || room.ventilationMeasure == 2)) return;
      room.airvolume.airvolume = Math.round((unit.airvolume.nl / unit.airvolume.totalFrZuKorr) * room.airvolume.fZuKorr);
      if (room.getRoomtypeAirvolume() > room.airvolume.airvolume) {
        changes = true;
        room.airvolume.fZuKorr = +parseFloat((room.getRoomtypeAirvolume() * unit.airvolume.totalFrZuKorr) / unit.airvolume.nl).toFixed(1);
        return;
      }
    }.bind(this)
  );
  if (changes === true && intervalCounter < 10) {
    intervalCounter++;
    calculateDefaultSupplyAir();
  } else {
    intervalCounter = 0;
  }
}

function checkDefaultSupplyAir() {
  let totalSupplyAir = 0;
  if (unit.rooms.some((room) => room.airType == 2 && (room.getRoomtypeAirvolume() > room.airvolume.airvolume || Math.abs(room.airvolume.getDefaultFzu() - room.airvolume.fZuKorr) > room.airvolume.getDefaultFzuDelta()))) {
    unit.rooms.forEach((room) => {
      if (room.airType != 2) return;
      room.airvolume.airvolume = room.getRoomtypeAirvolume();
      room.airvolume.isDefault = true;
      totalSupplyAir += room.airvolume.airvolume;
    });
    if (totalSupplyAir > unit.airvolume.nl) {
      unit.airvolume.nl = totalSupplyAir;
    } else if (totalSupplyAir < unit.airvolume.nl) {
      let difference = unit.airvolume.nl - totalSupplyAir;
      if (
        !unit.rooms.some((room) => {
          if (room.type == 8) {
            room.airvolume.airvolume += Math.round(difference);
            return true;
          } else return false;
        })
      ) {
        let maxSpace = 0;
        let roomId = -1;
        unit.rooms.forEach((room, id) => {
          if (room.airType == 2) {
            if (maxSpace < room.space) {
              maxSpace = room.space;
              roomId = id;
            }
          }
        });
        if (roomId >= 0) {
          unit.rooms[roomId].space += difference;
        }
      }
    }
  }
}

function calculateExhaustAir() {
  unit.airvolume.totalExhaustAir = 0;
  let nl = unit.airvolume.nl;
  if (unit.airvolume.totalSupplyAir > 0) nl = unit.airvolume.totalSupplyAir;

  unit.rooms.forEach((room) => {
    if (room.airType != 1) return;
    if (room.ventilationMeasure == 7) {
      room.airvolume.airvolume = 0;
      return;
    }

    room.airvolume.airvolume = Math.round((room.getRoomtypeAirvolume() * nl) / unit.airvolume.exhaustAir);
    unit.airvolume.totalExhaustAir += room.airvolume.airvolume;
  });
}

function calculateTotalAirvolumes() {
  unit.airvolume.totalSupplyAir = 0;
  unit.airvolume.totalExhaustAir = 0;

  unit.rooms.forEach(
    function (room) {
      if (room.ventilationMeasure == 7) {
        room.airvolume.airvolume = 0;
        return;
      }
      if (room.airType == 2) {
        unit.airvolume.totalSupplyAir += parseFloat(room.airvolume.airvolume);
        room.airvolume.nlZu = +parseFloat(room.airvolume.airvolume).toFixed(0);
        room.airvolume.nlAb = "-";
      } else if (room.airType == 1) {
        unit.airvolume.totalExhaustAir += parseFloat(room.airvolume.airvolume);
        room.airvolume.nlAb = +parseFloat(room.airvolume.airvolume).toFixed(0);
        room.airvolume.nlZu = "-";
      }
      room.airvolume.rl = room.airvolume.airvolume * fLstrl;
      room.airvolume.il = room.airvolume.airvolume * fLstil;
      room.airvolume.fl = room.airvolume.airvolume * fLstfl;
    }.bind(this)
  );
  unit.airvolume.totalSupplyAir = Math.round(unit.airvolume.totalSupplyAir);
  unit.airvolume.totalExhaustAir = Math.round(unit.airvolume.totalExhaustAir);
}

function calculateAirvolumeVariations() {
  unit.airvolume.nl = Math.round(unit.airvolume.nl);
  unit.airvolume.rl = Math.round(unit.airvolume.nl * fLstrl);
  unit.airvolume.il = Math.round(unit.airvolume.nl * fLstil);
  unit.airvolume.fl = Math.round(unit.airvolume.nl * fLstfl);

  unit.airvolume.nlExchange = +parseFloat(unit.airvolume.nl / unit.airvolume.volume).toFixed(2);
  unit.airvolume.rlExchange = +parseFloat(unit.airvolume.rl / unit.airvolume.volume).toFixed(2);
  unit.airvolume.ilExchange = +parseFloat(unit.airvolume.il / unit.airvolume.volume).toFixed(2);
  unit.airvolume.flExchange = +parseFloat(unit.airvolume.fl / unit.airvolume.volume).toFixed(2);
}

function calculateUld() {
  let f_uld = 3.1;
  let p_uld = 1.5;
  if (unit.overflowSeal == 1) var k_dichtung = 25;
  if (unit.overflowSeal == 0) var k_dichtung = 0;

  unit.rooms.forEach((room) => {
    let airvolume = 0;
    if (room.airvolume.operationmodeAirvolume > 0) airvolume = RoomtypesHasOperationmodesHasAirvolume.find(room.airvolume.operationmodeAirvolume).duration_airvolume;
    if (airvolume <= 0 || airvolume == null) airvolume = room.airvolume.airvolume;
    if (airvolume <= 0 || airvolume == null) {
      room.airvolume.uld = 0;
      return;
    }
    room.airvolume.uld = +parseFloat((f_uld * airvolume) / Math.pow(p_uld, 0.5) - k_dichtung).toFixed(0);
  });
}
